import React, { useEffect } from 'react';
//Components
import NuevoProducto from './NuevoProducto';
import Alerta from './Alerta';
import TablaProductos from './TablaProductos';
import ProductosPorLinea from './ProductosPorLinea';
import { ProductosLineasProvider } from './ProductosLineasContext';
import EditProduct from './EditProduct';
import DeleteProduct from './DeleteProduct';
//import ProductList from './ProductsList';
//Style
import '../../popup.css';
import '../../productos.css';
//Material-UI
import { Snackbar } from '@material-ui/core';
//Icons
import { AlertTriangle, Check, InfoCircle } from 'tabler-icons-react';
//Context
import { ProductosProvider } from './ProductosContext';
import { useProductos } from './ProductosContext';

function Productos() {
    const {
        getProducts,
        getLines,
        abrir,
        deleteProd,
        alerta,
        snackbar,
        setSnackbar,
        msgSb,
        severitySb,
    } = useProductos();
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(false);
    };

    useEffect(() => {
        getProducts();
        getLines();
    }, [getLines, getProducts]);

    return (
        <div className="productos-page">
            <div className="productos-header">
                <div className="productos-header-left">
                    <h1 className="titulo">Productos</h1>
                    <p className="desc">
                        Agregar, editar y borrar productos, así como la información relacionada a
                        ellos.
                    </p>
                </div>
            </div>

            <Snackbar
                open={snackbar}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className={`app-notif app-notif--${severitySb}`}>
                    {severitySb === 'success' && <Check size={20} strokeWidth={2} color="#fff" />}
                    {severitySb === 'error' && (
                        <AlertTriangle size={20} strokeWidth={2} color="#fff" />
                    )}
                    {severitySb === 'info' && <InfoCircle size={20} strokeWidth={2} color="#fff" />}
                    <span className="app-notif__msg">{msgSb}</span>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>
            <Alerta
                abrir={abrir}
                colorButton="default"
                buttonClass=""
                textButton="Borrar"
                popupSeconButton="Cancelar"
                popupsbclass="btn-del-cnl"
                isContained="text"
                popupTitle={
                    <div className="icon-big">
                        <AlertTriangle size={120} color="#7D7F90" />
                    </div>
                }
                popupBody={
                    <div className="popup-delete">
                        <form onSubmit={deleteProd}>
                            <div className="message">
                                No se pudo guardar la información:
                                <p className="popup-delete-detail"> {alerta} </p>
                            </div>
                        </form>
                    </div>
                }
            />

            <div className="productos-body">
                <div className="productos-main">
                    <div className="productos-card">
                        <div className="productos-card-toolbar">
                            <h3 className="productos-card-title">Productos</h3>
                            <div className="productos-card-actions">
                                <NuevoProducto />
                                <EditProduct />
                                <DeleteProduct />
                            </div>
                        </div>
                        <div className="productos-table-wrapper">
                            <TablaProductos />
                        </div>
                    </div>
                </div>
                <ProductosLineasProvider>
                    <ProductosPorLinea />
                </ProductosLineasProvider>
            </div>
        </div>
    );
}

const ProductosPage = () => (
    <ProductosProvider>
        <Productos />
    </ProductosProvider>
);

export default ProductosPage;
